import useHttpClient from "@/services/shared/useHttpClient";
import type { Ref } from "vue";
import type { CompanyGoal, CompanyGoalWithParticipation } from "@/models/companyGoal";
import type { MeGoalDetails } from "@/models/meGoalDetails";

const BASE_URL = "/api/me/goals";
const { get, post, loading } = useHttpClient();

interface UseMeGoalsServiceReturn {
  getFeaturedGoals: () => Promise<CompanyGoalWithParticipation[]>;
  getMyCurrentGoals: () => Promise<CompanyGoal[]>;
  getMyGoals: () => Promise<CompanyGoal[]>;
  getMyGoalDetails: (goalId: number) => Promise<MeGoalDetails>;
  participateInMyGoal: (goalId: number) => Promise<boolean>;
  getGoalPicture: (goalId: number) => Promise<Blob>;
  searchCompanyGoals: (searchTerm: string) => Promise<CompanyGoalWithParticipation[]>;
  loading: Ref<boolean>;
}

export default (): UseMeGoalsServiceReturn => {
  const getFeaturedGoals = (): Promise<CompanyGoalWithParticipation[]> => get(`${BASE_URL}/featured`);
  const getMyCurrentGoals = (): Promise<CompanyGoal[]> => get(`${BASE_URL}/current`);
  const getMyGoals = (): Promise<CompanyGoal[]> => get(BASE_URL);
  const getMyGoalDetails = (goalId: number): Promise<MeGoalDetails> => get(`${BASE_URL}/${goalId}`);
  const participateInMyGoal = (goalId: number) => post<boolean>(`${BASE_URL}/${goalId}/participate`);
  const getGoalPicture = (goalId: number): Promise<Blob> => get<Blob>(`${BASE_URL}/${goalId}/picture`, { responseType: "blob" });
  const searchCompanyGoals = (searchTerm: string, numberOfItems = 50): Promise<CompanyGoalWithParticipation[]> =>
    get(`${BASE_URL}/search?searchTerm=${searchTerm}&numberOfItems=${numberOfItems}`);

  return {
    getFeaturedGoals,
    getMyCurrentGoals,
    getMyGoals,
    getMyGoalDetails,
    participateInMyGoal,
    getGoalPicture,
    searchCompanyGoals,
    loading,
  };
};
